import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';

interface Props {
  onChange: (newValue: string | number) => void;
  value: string | number;
  type: string;
  label: string;
}

const InputField = ({ type, label, onChange, value }: Props) => {
  return (
    <FormContainer>
      <InputContainer>
        <Label>{label}</Label>
        <Input type={type} onChange={e => onChange(e.target.value)} value={value || ''} />
      </InputContainer>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  margin-right: 10px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 14px;
  margin-bottom: 14px;
  & + & {
    margin-top: 20px;
  }
`;
const Label = styled.div`
  width: 200px;
  margin-bottom: 4px;
  ${themes.fonts.FoundersGrotesk}
  font-size: 14px;
  text-transform: uppercase;
`;
const Input = styled.input`
  width: 100%;
  padding-bottom: 10px;
  border: 0;
  ${themes.fonts.DomaineDisplay}
  font-size: 24px;
  border-bottom: 1px solid black;
  background-color: transparent;
  text-align: left;
`;

export default InputField;
